import React from "react";
import { Modal } from "antd"
import { copyLinkHandler, referNowHandler } from "../../Utils/Referral"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const PaymentSuccessModal = (props) => {
    const {
        isOpen,
        onClose,
        referCode, 
    } = props

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={[]}
            title={[]}
            styles={{ padding: 0 }}
        >
            <div className="rounded-t-lg pt-3">
                <div className="flex flex-col items-center justify-center gap-3 py-5 pb-7 border-b-4 border-[#F6F5FA]">
                    <div className="p-[20px] bg-[#50A557] rounded-full" style={{ boxShadow: "0px 0px 10px #50A557" }}>
                        <CheckCircleIcon fontSize="large" htmlColor="#fff" />
                    </div>
                    <p className="font-[Gilroy-SemiBold] text-[20px] text-center">Payment successful.</p>
                </div>
                <div className="flex flex-col items-center justify-center gap-2 px-5 py-7">
                    <h2 className="font-[Gilroy-SemiBold] text-[25px] text-center">Get 20% extra discount when you refer…</h2>
                    <h3 className="font-[Gilroy-Medium] text-[18px] text-[#637381] text-center px-10">Refer now & earn more discounts.</h3>
                </div>
                <div className="mt-2 rounded-lg overflow-hidden bg-[#F6F5FA]">
                    <div className="flex flex-row items-center gap-1 p-1 pl-2.5">
                        <div className="flex-1 font-gilroy-medium text-[17px] text-black overflow-hidden">
                            {referCode
                                ? <p className="overflow-hidden text-[17px] text-ellipsis whitespace-nowrap">https://feedants.com/#/referral/{referCode}</p>
                                : <div className="place-self-center size-6 border-2 border-[#008080] border-t-white animate-spin rounded-full" />
                            }
                        </div>
                        <button className="p-2 rounded-lg font-gilroy-semibold text-[14px] text-[#008080] p-1 bg-white self-center" disabled={!referCode} onClick={() => copyLinkHandler(referCode)}>
                            Copy link
                        </button>
                    </div>
                    <button
                        className="w-full rounded-lg py-2.5 bg-[#008080] text-lg font-gilroy-semibold text-white" 
                        disabled={!referCode} 
                        onClick={() => referNowHandler(referCode)}
                    >
                        Refer Now
                    </button>
                </div>
            </div>    
        </Modal>
    )
}

export default PaymentSuccessModal;